import { render, staticRenderFns } from "./DingTalkLogin.vue?vue&type=template&id=c106ac66&scoped=true"
import script from "./DingTalkLogin.vue?vue&type=script&lang=js"
export * from "./DingTalkLogin.vue?vue&type=script&lang=js"
import style0 from "./DingTalkLogin.vue?vue&type=style&index=0&id=c106ac66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c106ac66",
  null
  
)

export default component.exports